module.exports = __webpack_public_path__ + "img/partner-page-bg.19e6b443.jpg";